import { makeStyles } from '@material-ui/core';
import { calculateHeight, calculateWidth, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(theme => ({
  cashOfficeTitleContainer: {
    flex: '1 1 0',
    height: '8.8vh',
    paddingTop: '0.4vh',
  },
  cashOfficeTitleHeader: {
    color: themeColor.defaultTextColor,
  },
  tenderPickupSubHeader: {
    color: theme.palette.info.main,
    letterSpacing: 0.44,
    lineHeight: 1.25,
    fontSize: vh(2.08),
    borderTop: `0.5vw solid ${theme.palette.secondary.main}`,
  },
  cashOfficeTitleHeaderLabel: {
    fontSize: vh(4.18),
    fontWeight: 500,
    lineHeight: 1.33,
    width: 'fit-content',
  },
  cashOfficeTitleAccountHeaderLabel: {
    fontSize: vh(3.125),
    fontWeight: 500,
    lineHeight: 1.165,
    paddingTop: calculateHeight(15).stringValue,
    paddingLeft: calculateWidth(20).stringValue,
  },
  amountSubHeader: {
    color: theme.palette.info.main,
    letterSpacing: 0.44,
    lineHeight: 1.25,
    fontSize: vh(2.08),
  },
  amountHeaderLabel: {
    fontSize: vh(3.64),
    fontWeight: 500,
    letterSpacing: 0.21,
    textAlign: 'end',
  },
  amountHeaderDesc: {
    fontSize: vh(2.08),
    letterSpacing: 0.44,
    lineHeight: 1.25,
    textAlign: 'end',
  },
  icon: {
    height: calculateHeight(24).stringValue,
    width: calculateHeight(24).stringValue,
  },
}));
